import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'resto-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
  imports: [MatButtonModule, TranslocoPipe],
})
export class ErrorBannerComponent {
  @Input() error!: string | null;

  reloadPage(): void {
    window.location.reload();
  }
}
